<template>
  <transition name="sg-loading-fade" @afterLeave="onAfterLeave">
    <div v-if="isShow" :id="id" :class="['sg-loading', fix ? 'sg-loading-mask' : '', customClass, ns.is(fullscreen ? 'fullscreen' : '')]" :style="maskStyle">
      <div :class="spinnerClass">
        <div v-if="!$slots.default" class="sg-loading-animation" :style="iconWrapperStyle">
          <sg-icon :size="circleRadius" class="circular" :color="color">
            <Loading class="path"/>
          </sg-icon>
        </div>
        <p class="sg-loading-text" :style="textStyle">
          <slot>{{ text }}</slot>
        </p>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, computed, onUnmounted, ref } from 'vue'
import { loadingProps } from './loading'
import { useGlobalComponentSettings } from '@sgui-plus/hooks'
import SgIcon from '@sgui-plus/components/icon'
import { Loading } from '@sgui-plus/icons-vue'
import { getLockTargetEl } from './getLockTargetEl'

export default defineComponent({
  name: 'SgLoading',
  props: loadingProps,
  inheritAttrs: false,
  components: {
    SgIcon,
    Loading
  },
  setup(props, { emit, expose }) {
    const { ns, zIndex } = useGlobalComponentSettings('loading')

    let visiable = ref(false)

    const circleRadiusMap = {
      large: 36,
      middle: 26,
      small: 16
    } as const

    const maskStyle = computed(() => {
      return {
        backgroundColor: props.backgroundColor
      }
    })

    const textStyle = computed(() => {
      return {
        color: props.color
      }
    })

    const iconWrapperStyle = computed(() => {
      return {
        height: circleRadiusMap[props.size] + 'px'
      }
    })

    const spinnerClass = computed(() => {
      const res = ['sg-loading-spinner']
      if (props.fix) res.push('sg-loading-fix')
      return res
    })

    const circleRadius = computed(() => {
      return circleRadiusMap[props.size]
    })

    const { lock, lockTarget } = props
    const hasLock = lock && lockTarget
    hasLock && handleLockScroll(lockTarget, 'hidden')

    function handleLockScroll (name: string, overflow: string) {
      let target: HTMLElement | null = getLockTargetEl(name)
      target && (target.style.overflow = overflow)
    }

    function show () {
      visiable.value = true
    }

    function hide () {
      visiable.value = false
    }

    function onAfterLeave (event) {
      emit('after-leave', event)
    }

    const isShow = computed(() => {
      return props.fullscreen ? props.visible : true
    })

    onUnmounted(() => {
      hasLock && handleLockScroll(lockTarget, 'auto')
    })

    expose({
      ns,
      zIndex
    })

    return {
      ns,
      show,
      hide,
      isShow,
      maskStyle,
      textStyle,
      iconWrapperStyle,
      spinnerClass,
      circleRadius,
      onAfterLeave,
      handleLockScroll
    }
  },
})
</script>
